<script setup lang="ts">
const { data } = useProducts('/aunivers')

const packet = inject(keys.currentPacket)

const products = computed(() => data.value?.filter((p) => p.id !== packet?.value?.id))
</script>

<template>
  <section class="bg-green-50 py-legacy-xl">
    <UContainer class="flex flex-col gap-legacy-l">
      <h2 class="text-center font-headline text-3xl leading-10 font-normal tracking-[1px] text-white">
        Flere digitale læringsunivers
      </h2>
      <ul class="grid grid-cols-1 gap-legacy-m sm:grid-cols-3">
        <li v-for="product in products" :key="product.id">
          <CardsRelated :product="toProductCard(product)" />
        </li>
      </ul>

      <PacketRelatedCta
        text="Se også hele utvalget vårt av bøker og læremidler"
        :link-to="{ name: 'products' }"
        link-label="Gå til produktkatalogen"
      />
    </UContainer>
  </section>
</template>
